import page from 'page'

import { loadPageStarter } from '../../config/app-starter.js'
import { showPageCopyPgFromMongo } from './pg-copy-pg-from-mongo/index.js'

export function setupMongoToPgRoutes (baseRoute) {
  /**
   * Feb 2025: PG page
   */
  page(`${baseRoute}/a/:mongoAccountId/admin-copy-pg-from-mongo`, async function (context) {
    const { mongoAccountId } = context.params
    await loadPageStarter({ accountId: mongoAccountId })

    showPageCopyPgFromMongo(mongoAccountId)
  })
}
